import { Outlet, useLocation } from 'react-router-dom'

import { Header } from '../components/Header'
import { Footer } from '../components/Footer'
import { AppProvider, EnvironmentType } from '../context/AppContext'
import { IAvailableApps } from '../utils/availableApps'
import { BaseHeader } from '../components/BaseHeader'
import { WithAuth } from '../containers/hoc/WithAuth'

import { CustomToastContainer } from 'brokertslib/src/components/CustomToastContainer'
import { useLayoutEffect } from 'react'

export interface BaseLayoutProps {
  app: IAvailableApps['appId'] | null
  environment?: EnvironmentType
}

const _BaseLayout = ({ app }: BaseLayoutProps) => {
  const location = useLocation();
  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <AppProvider app={app}>

      {app && <Header />}
      {!app && <BaseHeader />}

      <Outlet />

      <CustomToastContainer />

      <Footer />
    </AppProvider>
  )
}

export const BaseLayout = WithAuth(_BaseLayout)
